export default "__VITE_ASSET__DamTmneZ__"